import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { AssetMoveRequestCancelApi } from "../../../services/AssetService";
import { Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { FaUndoAlt } from "react-icons/fa";
const AssetMoveCancelModal = ({ assetData, open, onClose, afterSubmit }) => {
  const { id,movement } = assetData || {};
  const [remark, setRemark] = useState("");
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (open) {
      setRemark("");
    }
  }, [open]);
  const handleConfirm = () => {
    setLoading(true);
    AssetMoveRequestCancelApi(id,{ remarks: remark })
      .then((res) => {
        toast.success("Move Cancel Successfully");
        afterSubmit();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle className="d-flex align-items-center gap-2 text-danger">
        <FaUndoAlt className="fs-4" />
        <span>Cancel Move Request</span>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" className="mb-2">
          Are you sure you want to cancel move request?
        </Typography>
        <div className="border rounded p-3 bg-light mb-2">
          <Typography variant="body2" className="mb-1">
            <strong>From Location:</strong> {movement?.from_location?.name || "-"}
          </Typography>
          <Typography variant="body2">
            <strong>To Location:</strong> {movement?.to_location?.name || "-"}
          </Typography>
        </div>
        <TextField
          autoFocus
          label="Remark"
          multiline
          rows={2}
          fullWidth
          value={remark}
          onChange={(e) => setRemark(e.target.value)}
          placeholder="Enter remarks..."
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="error"
        >
          {loading && <Spinner animation="border" size="sm" />}
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AssetMoveCancelModal;
